// Stamps a PNG with its resolution (a pHYs chunk), so a 2× chart prints at the size it looks on
// screen instead of twice as large. Browsers' canvas encoders leave the chunk out.

const CRC_TABLE = (() => {
  const t = new Uint32Array(256);
  for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    t[n] = c >>> 0;
  }
  return t;
})();

export function crc32(bytes: Uint8Array): number {
  let c = 0xffffffff;
  for (const b of bytes) c = CRC_TABLE[(c ^ b) & 0xff] ^ (c >>> 8);
  return (c ^ 0xffffffff) >>> 0;
}

/** `png` with a pHYs chunk for `dpi` right after its header, replacing any it had. */
export function withDpi(png: Uint8Array, dpi: number): Uint8Array {
  const view = new DataView(png.buffer, png.byteOffset, png.byteLength);
  // The signature is 8 bytes, then IHDR: length (4), type (4), 13 bytes of data, CRC (4).
  const afterHeader = 8 + 8 + 13 + 4;
  if (png.length < afterHeader || String.fromCharCode(...png.subarray(12, 16)) !== 'IHDR') return png;
  const ppm = Math.round(dpi / 0.0254);
  const chunk = new Uint8Array(4 + 4 + 9 + 4);
  const c = new DataView(chunk.buffer);
  c.setUint32(0, 9);
  chunk.set([0x70, 0x48, 0x59, 0x73], 4); // "pHYs"
  c.setUint32(8, ppm);
  c.setUint32(12, ppm);
  chunk[16] = 1; // the unit is the meter
  c.setUint32(17, crc32(chunk.subarray(4, 17)));
  // Leave out an existing pHYs chunk so there's only one.
  const parts: Uint8Array[] = [png.subarray(0, afterHeader), chunk];
  let at = afterHeader;
  while (at + 8 <= png.length) {
    const len = view.getUint32(at);
    const type = String.fromCharCode(...png.subarray(at + 4, at + 8));
    const end = at + 12 + len;
    if (type !== 'pHYs') parts.push(png.subarray(at, end));
    at = end;
  }
  const out = new Uint8Array(parts.reduce((s, p) => s + p.length, 0));
  let o = 0;
  for (const p of parts) {
    out.set(p, o);
    o += p.length;
  }
  return out;
}
